import $ from '../vendor/jquery';

$(function() {
  //Add required fields to freeform
  $('.freeform-required').parent().find('.freeform-input').attr('required','true');

  //Form validation
  $('form').each(function() {
    $(this).validate({
      highlight: function (element, errorClass, validClass) {
        $(element).parents(".freeform-column").addClass("invalid");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents(".freeform-column").removeClass("invalid");
        $("button[type=submit]").removeAttr("disabled");
      },
      errorElement: 'em',
      errorPlacement: function (error, element) {
        if (element.parent().is('.custom-select')) {
          error.insertAfter($(element).parent());
        } else if (element.closest('.freeform-field-type--checkbox_group').length > 0) {
          error.appendTo($(element).closest('.freeform-field-type--checkbox_group'));
        } else if (element.closest('.freeform-field-type--radio_group').length > 0) {
          error.appendTo($(element).closest('.freeform-field-type--radio_group'));
        } else if (element.attr("type") == "checkbox") {
          error.insertAfter($(element).parents('.freeform-column').find('.freeform-required'));
        } else {
          error.insertAfter($(element));
        }
      },
      validClass: 'success',
      rules: {
        email: {
            email: true
        }
      },
      submitHandler: function(form){
        form.submit();
      }
    });
  });
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/forms.js